import React from 'react';
import { Outlet } from 'react-router-dom';
import MemberNavigation from './MemberNavigation';

const MemberLayout: React.FC = () => {
  return (
    <>
      <MemberNavigation />
      <Outlet />
    </>
  );
};

export default MemberLayout;
